module.exports = __webpack_public_path__ + "static/media/MHeiHK-Xbold.599e95b9.svg";